import { View } from "react-native";

export const Divider = () => <View className="bg-sky-lighter h-1.5 md:h-0.5" />;

export default Divider;
